import { isPlatformBrowser } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Router } from '@angular/router';
import { CartObserverService } from './../../../services/cart-observer.service';
import { CartService } from 'src/app/services/cart.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit, Output, EventEmitter, PLATFORM_ID } from '@angular/core';
import { Item } from '@models/cart.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-delete-missing-products-modal',
    templateUrl: './delete-missing-products-modal.component.html',
    styleUrls: ['./delete-missing-products-modal.component.scss'],
    standalone: true,
    imports: [LottieComponent, MatFormFieldModule, MatButtonModule, TranslateModule]
})
export class DeleteMissingProductsModalComponent implements OnInit {

  public productsToDelete: Item[] = [];
  public loading = false;
  @Output() reload = new EventEmitter();
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };
  constructor(
    private dialog: MatDialogRef<DeleteMissingProductsModalComponent>,
    private cartService: CartService,
    private cartObserver: CartObserverService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { res: { items: { sku: number }[]; no_stock: { sku: number }[] }, cart: Item[]; type?: string },
    @Inject(PLATFORM_ID) private platformId: string
  ) { }

  ngOnInit(): void {
    if (this.data.res?.items?.length) {
      for (const item of this.data.res.items) {
        this.productsToDelete = this.data.cart.filter((product: Item) => product.item_id === item.sku);
      }
    } else if (this.data.res?.no_stock?.length) {
      for (const item of this.data.res.no_stock) {
        this.productsToDelete = this.data.cart.filter((product: Item) => product.item_id === item.sku);
      }
    }
  }

  public closeModal(status: boolean): void {
    this.dialog.close(status);
  }

  public async deleteProductsAndContinue(): Promise<void> {
    this.loading = true;
    for (const product of this.productsToDelete) {
      await this.onRemoveProduct(product);
    }
    if (this.data.cart.length > this.productsToDelete.length) {
      this.loading = false;
      this.reload.emit();
      this.onEmitReload();
      await this.router.navigate(['/carrito/sugerencias']);
      this.closeModal(true);
      if (isPlatformBrowser(this.platformId)) {
        window.scroll(0, 0);
      }
    } else {
      this.reload.emit();
      this.onEmitReload();
      this.loading = false;
      this.closeModal(true);
    }
  }

  public async deleteProducts(): Promise<void> {
    try {
      this.loading = true;
      for (const product of this.productsToDelete) {
        await this.onRemoveProduct(product);
      }
      this.loading = false;
      this.closeModal(true);
    } catch (error) {
      this.loading = false;
    }
  }

  public async onRemoveProduct(product: any): Promise<void> {
    try {
      await this.cartService.onHandlingRemoveProduct(product.item_id);
    } catch (error) {
    }
  }

  public onEmitReload(): void {
    this.cartObserver.cart$.emit(true);
  }

}
